module.exports = __webpack_public_path__ + "img/clock_blue.44653fe2.svg";